"use strict";
var GenerateObservable_1 = require('./GenerateObservable');
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/rxjs/observable/generate.js
// module id = ../../../../rxjs/observable/generate.js
// module chunks = 3